import { Visitor } from 'graphql/generated/graphqlTypes';
import { useSearch } from './useSearch';

const keyManagerSearchColumns = ['name', 'email'];

export function useKeyManagerSearch({ members, search }: { members: Visitor[]; search: string }): Visitor[] {
  return useSearch({ data: members, search, keys: keyManagerSearchColumns });
}
